export default __webpack_public_path__ + "static/forest-poivet-49711c8a786d714daf953718b7c3ca6b.webp";